module.exports = __webpack_public_path__ + "static/Imagen-be99dd0fe085b900ec59dd60a77d95d4.jpg";